import { formatTimeRange } from '@op-bridge/bridge-core';
import { Box } from '@node-real/uikit';

interface CountDownTimerProps {
  time: number;
  status: number;
  prefix: string;
}

export const CountDownTimer = (props: CountDownTimerProps) => {
  const { time, status, prefix } = props;
  const timeDiff = time * 1000 - Date.now();

  if (timeDiff < 60000 && status === 3) {
    return <Box>Waiting to Finalize (almost there)</Box>;
  }
  // If the 60 mins countdown is over and the status still hasn't changed to "Ready to Prove".
  // change the wording to "Waiting to Prove (almost there)"
  if (timeDiff < 0 && status === 1) {
    return <Box>Waiting to Prove (almost there)</Box>;
  }

  return (
    <Box>
      {prefix}{' '}
      <span style={{ whiteSpace: 'nowrap' }}>
        (~
        {timeDiff < 60000
          ? formatTimeRange(time * 1000, Date.now())
          : formatTimeRange(time * 1000, Date.now())}{' '}
        remaining)
      </span>
    </Box>
  );
};
